var ItrackType;
(function (ItrackType) {
    ItrackType[ItrackType["CLICK"] = 1] = "CLICK";
    ItrackType[ItrackType["CLOSE"] = 2] = "CLOSE";
    ItrackType[ItrackType["IMP"] = 3] = "IMP";
})(ItrackType || (ItrackType = {}));
const tracksKeyMap = {
    [ItrackType.CLICK]: 'click_tracks',
    [ItrackType.CLOSE]: 'close_tracks',
    [ItrackType.IMP]: 'imp_tracks',
};
const fsResourceEventMap = {
    [ItrackType.IMP]: { id: 'fs_resource_sw', label: '资源位-展现' },
    [ItrackType.CLICK]: { id: 'fs_resource_ck', label: '资源位-点击' },
    [ItrackType.CLOSE]: { id: 'fs_resource_close', label: '资源位-点击关闭' },
};
export { ItrackType, tracksKeyMap, fsResourceEventMap };
